import { createContext } from 'react';

const Context = createContext({
    piaohong: false,
});

export default Context;
